import {createEntitySlice} from 'utils/createEntitySlice';
import {Client} from '../../types/client';
import {ClientThunks} from './clientThunks';

export interface ClientState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  clients?: any;
  pagy?: any;
  client?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ClientState = {
  status: 'idle',
  error: null,
  clients: [],
  client: {},
  pagy: {},
  isEditing: false,
  activeTab: 'Visits',
};

const clientSlice = createEntitySlice<Client>({
  name: 'client',
  initialState,
  thunks: ClientThunks,
  entityKey: 'client',
  entitiesKey: 'clients',
  reducers: {},
});

export const {
  setEntity: setClient,
  setIsEditing,
  setActiveTab,
} = clientSlice.actions;
export {initialState as clientInitialState};
export default clientSlice.reducer;
